var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "services" }, [
    _c("div", { staticClass: "services__title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("services_1")) + "\n  ")
    ]),
    _c("div", { staticClass: "services__subtitle" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("services_2_1")) + "\n  ")
    ]),
    _c(
      "div",
      { staticClass: "services__content" },
      [
        _c(
          "services-item-view",
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-mobile-apps-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_11")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-web-based-tools-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_12")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-iot-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_13")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-ecommerce-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_14")) + "\n      ")
            ])
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "services__action" },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "work_index" } } },
          [
            _c("button-view", [
              _vm._v("\n        " + _vm._s(_vm.$t("button_4")) + "\n      ")
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d228a15a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d228a15a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/services-view.vue
// module id = 467
// module chunks = 50